export type PrintInk = 'red' | 'cyan';

const INK_SHADOW: Record<PrintInk, string> = {
  red: 'shadow-[6px_6px_0_var(--color-logo-red)]',
  cyan: 'shadow-[6px_6px_0_var(--color-logo-cyan)]',
};

/**
 * @param ink - Logo ink the hard offset prints in
 * @returns Classes for a print-treatment panel: paper stock, maroon keyline, one hard ink offset, no blur
 */
export function printPanelClass(ink: PrintInk = 'red') {
  return `rounded-[3px] border-2 border-maroon-900 bg-paper bg-grain text-maroon-900 ${INK_SHADOW[ink]}`;
}
